import React from 'react';
import { FormattedMessage } from 'react-intl';

let style = {
  backgroundColor: '#fff',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 10
};

const Loading = ({ show }) => {
  if (show === false) return null;
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={style}
    >
      {/* <FormattedMessage id="changeLangPage.loading" /> */}
      <h2 className="m-4">切換語系中...</h2>
      <h5>Changing language...</h5>
    </div>
  );
};

export default Loading;
